import { fetchAll, fetchFiltered, addMaintanceReason, show, edit } from '@/api/maintancereason'

const state = {
  all: [],
  isLoading: false,
  maintanceReasonById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const maintanceReason = await show(id)
      commit('setMaintanceReasonById', maintanceReason)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const maintanceReasons = await fetchAll()
      commit('setAll', maintanceReasons)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const maintanceReasons = await fetchFiltered(queriesParams)
      commit('setAll', maintanceReasons)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addMaintanceReason(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.maintanceReasonById = null
  },

  setAll (state, maintanceReasons) {
    state.all = maintanceReasons
  },

  setMaintanceReasonById (state, maintanceReason) {
    state.maintanceReasonById = {
      id: maintanceReason.id,
      name: maintanceReason.name,
      isActive: maintanceReason.isActive
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
